import { combineReducers } from "redux";
import utils from "../features/utils/utilsSlice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import cart from "../features/cart/cartSlice";
import users from "../features/users/usersSlice";
import orders from "../features/orders/ordersSlice";
import products from "../features/products/productsSlice";
import payments from "../features/payments/paymentsSlice";
import {
  configureStore,
  ThunkAction,
  AnyAction,
  Reducer,
  Action,
} from "@reduxjs/toolkit";

const appReducer = combineReducers({
  cart,
  payments,
  products,
  orders,
  users,
  utils,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === "utils/clearStorage") {
    storage.removeItem("persist:me");
    const { utils } = state;
    state = { utils } as RootState;
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "djeli",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
